// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","344":"FullPizza"}[chunkId] + "." + {"72":"72c4f76f","187":"7e634b4a","344":"225e3600"}[chunkId] + ".chunk.js";
};